import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import './SettingsPageSkeleton.css';

/**
 * Mirrors Settings page: Row mb-4 header + Row g-4 (Col lg-3 sidebar + Col lg-9 content)
 */
const SettingsPageSkeleton: React.FC = () => (
  <div className="py-4">
    {/* Header row */}
    <Row className="mb-4 align-items-center g-2 g-lg-4">
      <Col xs={12} lg={3}>
        <Skeleton width={120} height={32} borderRadius={6} />
      </Col>
    </Row>

    <Row className="g-4">
      {/* Sidebar — Col lg-3 */}
      <Col xs={12} lg={3} className="d-none d-lg-block">
        <Card className="shadow-sm border-0 mt-4" style={{ borderRadius: '15px' }}>
          {['Settings', 'Blocked Users', 'Delete Account'].map((_, i) => (
            <div
              key={i}
              className="d-flex align-items-center p-4"
              style={{ borderBottom: i < 2 ? '1px solid #f0f0f0' : 'none' }}
            >
              <Skeleton circle width={20} height={20} style={{ marginRight: 12, flexShrink: 0 }} />
              <Skeleton width={100} height={14} borderRadius={6} />
            </div>
          ))}
        </Card>
      </Col>

      {/* Content — Col lg-9 */}
      <Col xs={12} lg={9}>
        <Card className="border-0 shadow-sm" style={{ borderRadius: '15px' }}>
          <Card.Body className="p-4">
            {/* Form fields */}
            {[...Array(5)].map((_, i) => (
              <div key={i} className="mb-4">
                <Skeleton width={120} height={13} borderRadius={6} style={{ marginBottom: 8 }} />
                <Skeleton width="100%" height={44} borderRadius={8} />
              </div>
            ))}
            <Skeleton width={140} height={42} borderRadius={8} />
          </Card.Body>
        </Card>
      </Col>
    </Row>
  </div>
);

export default SettingsPageSkeleton;
